import { Biosimilar } from "../../../../@types";

export const getCoveredIBs = (biosimilars: Biosimilar[]) =>
  biosimilars.filter(
    biosimilar => biosimilar.is_interchangeable && biosimilar.on_formulary
  );

export const hasCoveredIBs = (biosimilars: Biosimilar[]) =>
  getCoveredIBs(biosimilars).length > 0;

/**
 * For 2 drugs, gets 2 biosimilars each for use in tests.
 * By default, one will be a covered IB and one not an IB and not covered, and the
 * covered IB will be different for the 2 drugs.
 * If a second argument, `makeAllInvalid` is passed as `true`, both biosimilars
 * will be invalid for each drug:
 * The first won't be an IB
 * The second won't be on the formulary
 */
export const getTestBiosimilars = (i: number, makeAllInvalid = false) => [
  {
    rxcui: "2563977",
    name: "Semglee (yfgn)",
    is_interchangeable: makeAllInvalid ? false : i === 0,
    on_formulary: makeAllInvalid || i === 0,
  },
  {
    rxcui: "2563976",
    name: "Insulin Glargine-yfgn",
    is_interchangeable: makeAllInvalid || i === 1,
    on_formulary: makeAllInvalid ? false : i === 1,
  },
];
